(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealElements(root = document) {
    const elements = root.querySelectorAll('.gm-reveal:not([data-gm-reveal-ready])');
    if (!elements.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset.gmRevealReady = 'true';
        element.classList.add('is-visible');
      });
      return;
    }

    document.documentElement.classList.add('gm-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    elements.forEach((element) => {
      element.dataset.gmRevealReady = 'true';
      observer.observe(element);
    });
  }

  function init() {
    revealElements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => revealElements(event.target));
})();
